import JQuery from 'jquery';
// eslint-disable-next-line
let $ = JQuery

export function setError(fieldName, error) {
  $(`#${  fieldName  }Error`).text(error);
  $(`input[name ="${fieldName}"]`).on('keyup', () => {
    $(`#${fieldName}Error`).text('');
  });
}

export function removeError(fieldName) {
  $(`#${fieldName}`).remove();
}

export function isValidCPF(value = '') {
  const cpf = value.replace(/\D/g, '');
  if (cpf.toString().length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
    return false;
  }
  let result = true;
  // eslint-disable-next-line
  var element = [9, 10];
  element.forEach((j) => {
    let sum = 0;
    let r;
    cpf
      .split(/(?=)/)
      .splice(0, j)
      .forEach((e, i) => {
        sum += parseInt(e, 10) * (j + 2 - (i + 1));
      });
    r = sum % 11;
    r = r < 2 ? 0 : 11 - r;
    if (r !== parseInt(cpf.substring(j, j + 1), 10)) {
      result = false;
    }
  });
  return result;
}

export function isValidCNPJ(value = '') {
  // Remove formatação, mantendo letras e números
  const cnpj = value.replace(/[^A-Z0-9]/gi, '').toUpperCase();

  if (cnpj.length !== 14) return false;

  // Rejeita sequências com todos os caracteres iguais (ex: 00000000000000)
  if (/^(.)\1+$/.test(cnpj)) return false;

  // Converte cada caractere para seu valor numérico conforme tabela da Receita Federal
  // Valor = ASCII - 48 (0='0'→0, A='A'→17, B→18, ..., Z→42)
  const charValue = (char) => char.charCodeAt(0) - 48;

  const calcDigit = (base) => {
    const len = base.length;
    let soma = 0;
    let pos = len - 7;

    for (let i = len; i >= 1; i--) {
      soma += charValue(base.charAt(len - i)) * pos--;
      if (pos < 2) pos = 9;
    }

    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  const base = cnpj.substring(0, 12);
  const digits = cnpj.substring(12);

  const firstDigit = calcDigit(base);
  if (firstDigit !== parseInt(digits.charAt(0))) return false;

  const secondDigit = calcDigit(base + firstDigit);
  if (secondDigit !== parseInt(digits.charAt(1))) return false;

  return true;
}

export function isValidUrl(text) {
  const isValid =
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g.test(
      text
    );
  return isValid;
}

export function isValidEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function isValidPhone(phone) {
  const re = /^\(?[0-9]{2}\)?\s?(\s?9?\s?){1}[0-9]{4}-?[0-9]{4}$/;
  if (
    /00000000|11111111|22222222|33333333|44444444|55555555|66666666|77777777|88888888|99999999/.test(
      phone.replace(/\D/g, '')
    )
  )
    return false;
  else if (re.test(phone || '')) return true;
  else return false;
}

export function isValidDocument(document, type = null) {
  // remove any character that is not a number and verify is a number
  const documentNumber = document.replace(/\D/g, '');
  if (isNaN(documentNumber)) {
    return false;
  }

  // documentos conhecidos invalidos
  const invalidDocuments = [
    null,
    undefined,
    '',
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999',
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999',
  ];

  if (invalidDocuments.includes(documentNumber)) {
    return false;
  }

  // switch case with type == cpf or cnpj default is both
  switch (type) {
    case 'cpf':
      return isValidCPF(documentNumber);
    case 'cnpj':
      return isValidCNPJ(documentNumber);
    default:
      return isValidCPF(documentNumber) || isValidCNPJ(documentNumber);
  }
}